import { motion } from "framer-motion";
import { React, useEffect, useState } from "react";
import { IoDownload } from "react-icons/io5";
import { ReactTyped } from "react-typed";
import { images } from "../../constants";
import sanityClient from "../../SanityClient";

const Header = () => {
  const [resumePDF, setResumePDF] = useState(null);

  const downloadResume = () => {
    if (resumePDF) {
      const link = document.createElement("a");
      link.href = resumePDF;
      link.download = "My_Resume.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  useEffect(() => {
    const fetchResumePDF = async () => {
      const data = await sanityClient.fetch(
        '*[_type == "resume"]{pdf{asset->{_id, url}}}'
      );
      setResumePDF(data[0]?.pdf.asset.url);
    };
    fetchResumePDF();
  }, []);

  return (
    <div id="home" className="hero">
      <motion.img
        src={images.logo}
        alt="profile"
        className="profile-img"
        whileInView={{ opacity: 1, scale: 1 }}
        initial={{ opacity: 0, scale: 0.5 }}
        transition={{ duration: 1, ease: "easeOut" }}
      />

      <motion.h1
        whileInView={{ opacity: 1, y: 0 }}
        initial={{ opacity: 0, y: 50 }}
        transition={{ duration: 1, ease: "easeOut" }}
      >
        <span className="block md:inline">I'm Ladle Patel, </span>
        <ReactTyped
          strings={[
            "A Data Scientist",
            "An AI Advisor",
            "An AI Strategist",
            "A ML Expert",
            "A Tech Leader",
          ]}
          typeSpeed={55}
          className="text-3xl md:text-6xl"
          backSpeed={50}
          style={{
            WebkitTextFillColor: "white",
            filter: "drop-shadow(2px 4px 6px black)",
          }}
          loop
        />
      </motion.h1>

      <motion.p
        whileInView={{ opacity: 1, y: 0 }}
        initial={{ opacity: 0, y: 50 }}
        transition={{ duration: 1.2, ease: "easeOut" }}
      >
        Have over 12 years of experience in AI strategy, Data Science, and
        Machine Learning. Skilled in AI/ML tools, Generative AI, and large-scale
        data solutions, I’m currently working as a Senior AI Advisor at Arab
        National Bank, leading AI transformation initiatives.
      </motion.p>

      <div className="hero-action">
        <motion.div
          className="hero-connect"
          whileInView={{ opacity: 1, x: 0 }}
          initial={{ opacity: 0, x: -50 }}
          transition={{ duration: 1, delay: 0.5, ease: "easeOut" }}
        >
          <a className="anchor-link" href="#contact">
            Connect with me
          </a>
        </motion.div>

        <motion.button
          onClick={downloadResume}
          className="hero-resume flex items-center space-x-2"
          whileInView={{ opacity: 1, x: 0 }}
          initial={{ opacity: 0, x: 20 }}
          transition={{ duration: 1, delay: 0.7, ease: "easeOut" }}
        >
          <IoDownload className="text-white" size={24} />
          <span>Resume</span>
        </motion.button>
      </div>
    </div>
  );
};

export default Header;
